import moment from 'moment'

/*
* 获取日时分秒
* */
export const getDayHourMinuteSecond = () => {
  let date = new Date()
  let [day, hour, minute, second] = [
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ].map(item => (item < 10 ? '0' + item : item))
  return '' + day + hour + minute + second
}

/**
 * 过去7天
 */
export const lastSevenDays = () => {
  return [moment().subtract(7, 'day'), moment()]
}

/**
 * 过去30天
 */
export const lastThirtyDays = () => {
  return [moment().subtract(30, 'day'), moment()]
}

/**
 * 两个日期相差几天
 */
export const getDays = (strDateStart, strDateEnd) => {
  let strSeparator = '-' //日期分隔符
  let oDate1 = strDateStart.split(strSeparator)
  let oDate2 = strDateEnd.split(strSeparator)
  let strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2])
  let strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2])
  let iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
  return iDays
}
